const PublicPage = () => {
  return <h1>Public page </h1>;
};

export default PublicPage;
